import { FormHelperText, styled } from '@mui/material';

export const StyledFormHelperText = styled(FormHelperText)({
  height: 20,
  marginTop: 4,
  marginLeft: 0,
  fontSize: 13,
  color: '#63717E',

  '& .Mui-error': {
    color: '#D82C0D',
  },
});
